/**
 * Rôles et leurs libellés — une seule liste pour tout l'écran.
 *
 * Le nom technique (OPERATOR_CLIENT) n'apparaît jamais à l'utilisateur : on
 * affiche le libellé. Sorti de Users.jsx le 03-10-2026 parce que Projects
 * avait sa propre liste, différente de celle du serveur (project.service.js:60).
 */
export const ROLES = ['ADMIN', 'COORDINATOR', 'OPERATOR', 'OPERATOR_CLIENT', 'SAV', 'FINANCE'];

// Rôle par défaut d'une équipe : la même liste plus OPERATOR_PERMANENT, qui
// existe côté serveur (routes/permissions.js) sans être attribuable à un compte
// depuis la fiche. Gardée ici pour que GroupsTab n'ait plus sa propre copie.
export const ROLES_DEFAUT_EQUIPE = [...ROLES, 'OPERATOR_PERMANENT'];

export const ROLE_LABELS = {
  SUPER_ADMIN: 'Accès total',
  ADMIN: 'Admin',
  COORDINATOR: 'Coordinator',
  OPERATOR: 'Operator',
  OPERATOR_CLIENT: 'Op. Client',
  OPERATOR_PERMANENT: 'Op. Permanent',
  SAV: 'SAV',
  FINANCE: 'Finance',
};

/** Libellé d'un rôle, ou le code brut s'il est inconnu (ne cache jamais une valeur). */
export function libelleRole(role) {
  return ROLE_LABELS[role] || role || '';
}

/**
 * La fiche d'un ACCÈS TOTAL n'est modifiable que par un accès total (règle du
 * serveur : assertFicheModifiable). L'écran n'offre pas les actions vouées au refus.
 * Sa propre fiche reste à soi.
 */
export function ficheReservee(cible, moi) {
  return cible?.role === 'SUPER_ADMIN' && moi?.role !== 'SUPER_ADMIN' && cible?.id !== moi?.id;
}
